import dateAdapter from '@/helpers/dayjsAdapter';

export const DAYS_UNIT = 'days';
export const HOURS_UNIT = 'hours';
export const WEEKS_UNIT = 'weeks';
export const MONTHS_UNIT = 'months';

export const CHART_JS_DAYS_UNIT = 'day';
export const CHART_JS_HOURS_UNIT = 'hour';
export const CHART_JS_WEEKS_UNIT = 'week';
export const CHART_JS_MONTHS_UNIT = 'month';

export const CHART_JS_UNITS = {
    [DAYS_UNIT]: CHART_JS_DAYS_UNIT,
    [HOURS_UNIT]: CHART_JS_HOURS_UNIT,
    [WEEKS_UNIT]: CHART_JS_WEEKS_UNIT,
    [MONTHS_UNIT]: CHART_JS_MONTHS_UNIT
};

export const LAST_5_MINUTES = 'last-5-minutes';

export const LAST_HOUR = 'last-1-hours';
export const LAST_3_HOURS = 'last-3-hours';
export const LAST_8_HOURS = 'last-8-hours';
export const LAST_12_HOURS = 'last-12-hours';
export const LAST_24_HOURS = 'last-24-hours';

export const YESTERDAY = 'YESTERDAY';

export const LAST_3_DAYS = 'last-3-days';
export const LAST_7_DAYS = 'last-7-days';
export const LAST_14_DAYS = 'last-14-days';
export const LAST_30_DAYS = 'last-30-days';
export const LAST_90_DAYS = 'last-90-days';

export const CUSTOM_TIME_RANGE = 'CUSTOM';

export const TIME_OPTIONS = [
    {
        label: 'Last full hour',
        value: LAST_HOUR,
        old_ui_value: 'hour'
    },
    {
        label: 'Last full 3 hours',
        value: LAST_3_HOURS,
        old_ui_value: 'trihours'
    },
    {
        label: 'Last full 8 hours',
        value: LAST_8_HOURS,
        old_ui_value: 'eighthours'
    },
    {
        label: 'Last full 12 hours',
        value: LAST_12_HOURS,
        old_ui_value: null
    },
    {
        label: 'Last full 24 hours',
        value: LAST_24_HOURS,
        old_ui_value: '24hours'
    },
    {
        label: 'Yesterday',
        value: YESTERDAY,
        old_ui_value: 'yesterday'
    },
    {
        label: 'Last full 3 days',
        value: LAST_3_DAYS,
        old_ui_value: 3
    },
    {
        label: 'Last full 7 days',
        value: LAST_7_DAYS,
        old_ui_value: 7
    },
    {
        label: 'Last full 14 days',
        value: LAST_14_DAYS,
        old_ui_value: 14
    },
    {
        label: 'Last full 30 days',
        value: LAST_30_DAYS,
        old_ui_value: 30
    },
    {
        label: 'Last full 90 days',
        value: LAST_90_DAYS,
        old_ui_value: 90
    },
    {
        label: 'Custom',
        value: CUSTOM_TIME_RANGE,
        old_ui_value: 'custom'
    }
];

export const findTimeOptionByValue = value => {
    const item = TIME_OPTIONS.find(option => option.value === value);
    return item?.label || value;
}

export const findTimeOptionByLabel = label => {
    const item = TIME_OPTIONS.find(option => option.label === label);
    return item?.value || ((label && label.includes('-')) ? label : null);
}

export const DAYS_RANGE = {
    name: DAYS_UNIT,
    values: [LAST_3_DAYS, LAST_7_DAYS, LAST_14_DAYS, LAST_30_DAYS, LAST_90_DAYS, CUSTOM_TIME_RANGE]
};
export const HOURS_RANGE = {
    name: HOURS_UNIT,
    values: [YESTERDAY, LAST_3_DAYS, LAST_HOUR, LAST_3_HOURS, LAST_8_HOURS, LAST_12_HOURS, LAST_24_HOURS, CUSTOM_TIME_RANGE]
};
export const MONTHS_RANGE = {
    name: MONTHS_UNIT,
    values: [LAST_90_DAYS, CUSTOM_TIME_RANGE]
};
export const WEEKS_RANGE = {
    name: WEEKS_UNIT,
    values: [LAST_30_DAYS, LAST_90_DAYS, CUSTOM_TIME_RANGE]
};
export const ALL_RANGES = [HOURS_RANGE, DAYS_RANGE, WEEKS_RANGE, MONTHS_RANGE];

export const getTimeUnitByCustomTimeRange = timeInUnix => {
    const daysDiff = dateAdapter.unix(timeInUnix[1]).diff(dateAdapter.unix(timeInUnix[0]), 'days');
    const monthsDiff = dateAdapter.unix(timeInUnix[1]).diff(dateAdapter.unix(timeInUnix[0]), 'months');

    return daysDiff < 1
        ? [HOURS_UNIT]
        : daysDiff < 7
        ? [DAYS_UNIT]
        : monthsDiff < 1
        ? [DAYS_UNIT, WEEKS_UNIT]
        : monthsDiff <= 6
        ? [DAYS_UNIT, WEEKS_UNIT, MONTHS_UNIT]
        : monthsDiff > 6
        ? [WEEKS_UNIT, MONTHS_UNIT]
        : [DAYS_UNIT];
};

export const getTimeUnitByCustomTimeRangeOriginal = timeInUnix => {
    const daysDiff = dateAdapter.unix(timeInUnix[1]).diff(dateAdapter.unix(timeInUnix[0]), 'days');
    const monthsDiff = dateAdapter.unix(timeInUnix[1]).diff(dateAdapter.unix(timeInUnix[0]), 'months');

    return daysDiff < 3
        ? [HOURS_UNIT]
        : daysDiff < 7
        ? [DAYS_UNIT, HOURS_UNIT]
        : monthsDiff < 1
        ? [DAYS_UNIT, WEEKS_UNIT]
        : monthsDiff <= 6
        ? [DAYS_UNIT, WEEKS_UNIT, MONTHS_UNIT]
        : monthsDiff > 6
        ? [WEEKS_UNIT, MONTHS_UNIT]
        : [DAYS_UNIT];
};

export const getEndTime = (timeInUnix, timeUnit) => {
    let endTime;

    const hour = 3600;
    const day = hour * 24;

    switch (timeUnit) {
        case HOURS_UNIT:
            endTime = timeInUnix + hour;
            break;
        case DAYS_UNIT:
            endTime = timeInUnix + day;
            break;
        case WEEKS_UNIT:
            endTime = timeInUnix + day * 7;
            break;
        default:
            endTime = timeInUnix;
    }

    return endTime;
};
